export default function controlsTemplate() {
  return `
  <div class="fra-m-slider__controls fra-js-slider__controls">
    <button type="button" class="fra-e-button fra-e-button--icon-only fra-js-slider__prev">
      <fra-e-icon class="fra-e-icon fra-e-button__icon" icon-id="fra-icon-chevron-left"></fra-e-icon>
    </button>
    <button type="button" class="fra-e-button fra-e-button--icon-only fra-js-slider__next">
      <fra-e-icon class="fra-e-icon fra-e-button__icon" icon-id="fra-icon-chevron-right"></fra-e-icon>
    </button>
  </div>
  `;
}
